import React from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom';

const Contens = ({ title, crumbs }) => {
  const location = useLocation();

  // default breadcrumb if none provided
  const finalCrumbs = crumbs && crumbs.length ? crumbs : [
    { name: 'Home', to: '/dashboard' },
    { name: title, to: location.pathname }
  ];

  return (
    <div style={{ background: "#f4f6f9" }}>
      <section className="content pt-2">
        <div className="container-fluid">

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.75rem'
          }}>

            <div style={{ flex: 1 }}>
              <div style={{
                background: 'transparent',
                padding: '6px 16px',
                borderRadius: 0,
                boxShadow: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <h1 style={{
                  margin: 0,
                  fontSize: '1.15rem',
                  color: '#222',
                  fontWeight: 600,
                  letterSpacing: '0.15px'
                }}>{title}</h1>

                <nav aria-label="breadcrumb" style={{ fontSize: '0.9rem', color: '#666', marginLeft: 'auto' }}>
                  {finalCrumbs.map((c, i) => (
                    <span key={i} style={{ display: 'inline-flex', alignItems: 'center' }}>
                      {i > 0 && <span style={{ color: '#bbb', margin: '0 0.4rem' }}>/</span>}
                      {i < finalCrumbs.length - 1 ? (
                        c.to && c.to !== '/#' && c.to !== '#' ? (
                          <Link to={c.to} style={{ color: '#007bff', textDecoration: 'none', fontWeight: 500 }}>{c.name}</Link>
                        ) : (
                          <span style={{ color: '#007bff', fontWeight: 500 }}>{c.name}</span>
                        )
                      ) : (
                        <span style={{ color: '#333', fontWeight: 600 }}>{c.name}</span>
                      )}
                    </span>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/* full-width white area below header */}
          <div className="page-full">
            <div className="container-fluid">
              <div className="page-card-inner">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contens